import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FacebookMediaUpload from '../../../../../ReusableFormFields/FacebookMediaUpload'
import Button from '../../../../../../components/Button'
import AdPreviewSoundControlWrapper from '../../../../../../features/components/FacebookPreviews/reusablePreviewComponents/AdPreviewSoundControlWrapper'
import FacebookSingleMediaAdPreview from '../../../../../../features/components/FacebookPreviews/FacebookSingleMediaAdPreview'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'

import useFlatFormikValues from '../../../useFlatFormikValues'
import useLineItemDetails from '../hooks/useLineItemDetails'

import { getFileError } from '../../../helpers'

import { recommendedFeedMediaSize } from '../../../../../../constants/ads'
import {
  FILE_URL,
  IMAGE_HASH,
  MEDIA_DURATION,
  MEDIA_FILE_OPTION,
  MEDIA_FORMAT,
  MEDIA_HEIGHT,
  MEDIA_RATIO,
  MEDIA_SIZE,
  MEDIA_WIDTH
} from '../../../../../ReusableFormFields/AdFileUpload/fields'

import useStyles from '../../../../../../styles/common/stepForms'

const fields = [FILE_URL, MEDIA_SIZE, MEDIA_WIDTH, MEDIA_HEIGHT, MEDIA_FORMAT, MEDIA_RATIO, MEDIA_DURATION, IMAGE_HASH]

const MediaFileStep = ({ formik, handleStepChange, isActive }) => {
  const [showError, setShowError] = useState(false)
  const { t } = useTranslation()
  const classes = useStyles()

  const { isVideoViews } = useLineItemDetails()

  const stepTitle = useMemo(() => (isVideoViews ? 'Select a video' : 'Select an image or video'), [isVideoViews])

  const { values, errors } = formik

  const error = getFileError(errors)
  const fileUrlError = errors[FILE_URL]

  const flatFormikValues = useFlatFormikValues({
    formikValues: values,
    allowUseSingleMediaItem: false
  })

  const handleContinue = useCallback(() => {
    setShowError(true)
    handleStepChange(fields)
  }, [handleStepChange])

  return (
    <>
      <div className={classes.stepTitle}>{t(stepTitle)}</div>
      <div className={classes.stepBody}>
        <AdPreviewSoundControlWrapper formikValues={flatFormikValues} isSoundDisabled={!isActive}>
          <FacebookSingleMediaAdPreview
            elementInProgress={MEDIA_FILE_OPTION}
            formikValues={flatFormikValues}
            isInProgress={true}
          />
        </AdPreviewSoundControlWrapper>
        <FacebookMediaUpload
          formik={formik}
          mediaFileError={error || (showError && fileUrlError)}
          mediaUrlError={error || (showError && fileUrlError)}
          recommendedSize={recommendedFeedMediaSize}
          isSingleMedia
          allowImage={!isVideoViews}
        />
        {errors[IMAGE_HASH] && <ErrorMessage error={errors[IMAGE_HASH]} />}
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

MediaFileStep.propTypes = {
  handleStepChange: PropTypes.func
}

export default MediaFileStep
